import React, { useEffect } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useNews } from 'contexts/news'
import { useEntities } from 'state/entities'
import { useLocation } from 'react-router-dom'
import { useOrganization } from 'contexts/organization'
import { compact } from 'utilities/array'
import Paragraph from 'components/typography/paragraph'
import Filter from 'components/filter'

const salt = 'news:published'

const PublishedFilter = props => {
    const { formatMessage } = useIntl()

    const {
        filter = {},
        setNewsFilter: setFilter,
        articles: items = [],
        fetching,
        hasFetched
    } = useNews()

    const { state } = useLocation()
    const { organization } = useOrganization()

    const { items: tags } = useEntities({
        path: '/articles/tags',
        queryOptions: {
            key: ['articles', 'tags'],
            exhaustive: true
        },
        adaptItems: items => items
            .filter(({ count }) => !!count)
            .map(({ name }) => ({ id: name, name }))
    })

    useEffect(() => {
        if(!!state?.filter?.tags?.length) {
            setFilter({ tags: state.filter.tags })
        }
    }, [state?.filter, setFilter])

    const advancedFields = compact([
        organization && {
            type: 'shareOrEveryone',
            name: 'sharedIn',
            label: formatMessage({
                id: 'label_shared_with',
                defaultMessage: 'Shared with'
            }),
            types: ['group'],
            shareLabel: formatMessage({
                id: 'label_groups_specific',
                defaultMessage: 'Specific groups'
            }),
            shareContent: !filter.sharedIn?.length ? (
                <Paragraph className="caption compact">
                    <FormattedMessage
                        id="news_filter_access_default_information"
                        defaultMessage="Only news directly shared with the selected groups." />
                </Paragraph>
            ) : null,
            everyoneLabel: organization.name,
            everyoneContent: (
                <Paragraph className="caption compact">
                    <FormattedMessage
                        id="news_filter_access_everyone_information"
                        defaultMessage="Only news directly shared with {organization}."
                        values={{ organization: organization.name }} />
                </Paragraph>
            ),
            empty: []
        },
        {
            type: 'checkboxes',
            name: 'tags',
            label: formatMessage({
                id: 'noun_tags',
                defaultMessage: 'Tags'
            }),
            field: {
                options: tags,
                defaultValue: []
            },
            empty: []
        }
    ])

    return (
        <Filter
            {...props}
            filter={filter}
            setFilter={setFilter}
            advancedFields={advancedFields}
            items={items}
            fetching={fetching}
            hasFetched={hasFetched}
            preferDefaultValue
            salt={salt} />
    )
}

export default PublishedFilter